export enum ModalRoleEnum {
  CONFIRM = 'CONFIRM',
  CANCEL = 'CANCEL'
}


export enum ApplicantModalEnum {

}
